export default __webpack_public_path__ + "static/media/Home Shifting1.1e672ce1.jpg";